import React from "react";
import {useCsContext} from "../../state/CsInstance";
import {observer} from "mobx-react-lite";

import {
	THEATER_RENDER_HEIGHT,
	THEATER_RENDER_WIDTH,
} from "../../state/userInputStore";

import styles from "./CoordinateDisplay.module.css";

type Props = {
	style?: React.CSSProperties;
};

const OFFSET = 10;

function CoordinateDisplay({style}: Props) {
	const {userInputStore, uiStore, compileStore} = useCsContext();
	const {mouseX, mouseY, theaterScale} = userInputStore;

	if (
		!uiStore.showCoordinates ||
		compileStore.error ||
		!userInputStore.mouseInBounds
	) {
		return <></>;
	}

	let offsetTop = (THEATER_RENDER_HEIGHT / 2 - mouseY) * theaterScale + OFFSET;
	let offsetLeft = (THEATER_RENDER_WIDTH / 2 + mouseX) * theaterScale + OFFSET;

	if (offsetTop + 16 > THEATER_RENDER_HEIGHT * theaterScale) {
		offsetTop -= 32;
	}
	if (offsetLeft + 60 > THEATER_RENDER_WIDTH * theaterScale) {
		offsetLeft -= 120;
	}

	return (
		<div
			id="coordinateDisplay"
			className={styles.text}
			style={{
				top: offsetTop,
				left: offsetLeft,
				zIndex: 1,
				...style,
			}}
		>
			{mouseX.toFixed(1)}, {mouseY.toFixed(1)}
		</div>
	);
}

export default observer(CoordinateDisplay);
